export enum EQuickEntryCommandTrigger {
  Command = '/',
  Student = '@',
}

export enum EQuickEntryEscapeAction {
  CloseSuggestions = 'closeSuggestions',
  ClosePopover = 'closePopover',
  Collapse = 'collapse',
  ConfirmDiscard = 'confirmDiscard',
}

export enum EQuickEntryKind {
  PerformanceAssessment = 'performanceAssessment',
  Note = 'note',
  SupportMeasure = 'supportMeasure',
}

export enum EQuickEntryPopover {
  Students = 'students',
  Subject = 'subject',
  EntryType = 'type',
  Competences = 'competences',
  Date = 'date',
}

export enum EQuickEntrySuggestionKind {
  Note = 'note',
  PerformanceAssessment = 'performanceAssessment',
  SupportMeasure = 'supportMeasure',
  Subject = 'subject',
  OpenCompetences = 'openCompetences',
  OpenStudents = 'openStudents',
  OpenSubject = 'openSubject',
  Student = 'student',
  AllEligibleStudents = 'allEligibleStudents',
}
